import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ChunkLoadErrorHandler } from './services/chunk-load-error.handler';
import { TranslateModule } from '@ngx-translate/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // PreloadAllModules scarica i chunk delle rotte lazy subito dopo la navigazione iniziale,
    // quando il build appena servito e' ancora quello corrente: cosi' una scheda lasciata aperta
    // per ore non va a cercare un chunk rimosso da un deploy successivo (vedi ChunkLoadErrorHandler).
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    TranslateModule.forRoot({
      fallbackLang: 'en'
    }).providers!,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
};
